import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';

const ToastContext = createContext(null);

const KIND_STYLES = {
  success: 'border-l-steam-success',
  info:    'border-l-accent',
  warn:    'border-l-steam-warn',
  error:   'border-l-steam-danger'
};

function Toast({ toast, onDismiss }) {
  const { id, kind = 'info', message } = toast;
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(id), 2000);
    return () => clearTimeout(timer);
  }, [id, onDismiss]);
  const barClass = KIND_STYLES[kind] || KIND_STYLES.info;
  return (
    <div
      role="status"
      className={`bg-surface-panel border border-surface-border border-l-[3px] ${barClass} px-4 py-3 text-sm text-surface-text cursor-pointer shadow-lg min-w-[240px] max-w-[360px]`}
      onClick={() => onDismiss(id)}
    >
      {message}
    </div>
  );
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(1);

  const push = useCallback((toast) => {
    const id = nextId.current++;
    setToasts((prev) => [...prev, { id, ...toast }]);
  }, []);

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ push }}>
      {children}
      <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 items-end pointer-events-none">
        {toasts.map((t) => (
          <div key={t.id} className="pointer-events-auto">
            <Toast toast={t} onDismiss={dismiss} />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    return { push: () => {} };
  }
  return ctx;
}
